module.exports = __webpack_public_path__ + "media/src/web/images/home/heroimg_baseline_with_plan-cd220cbb68fd62094663d264082eb1f8.jpg";